export enum FightStrategy {
    MaxDmgToEnemy = 'Max Dmg To Enemy',
    MinDmgToSelf = 'Min Dmg To Self',
    Strike = 'Strike',
    Parry = 'Parry',
}

export default FightStrategy;